const FollowersColumn = () => {
    return (
      <div className="followers-column">
          <h1>Followers Column</h1>
      </div>
    );
  }
  
  export default FollowersColumn;
  